import './style/index.js';

import _TagInput from './tag-input.jsx';

export type { TagInputProps } from './tag-input.jsx';
export const TagInput = _TagInput;
export default TagInput;

export * from './type';
